import { render } from "./FooterItem.vue?vue&type=template&id=0cbaa6f0"
import script from "./FooterItem.vue?vue&type=script&lang=js"
export * from "./FooterItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__